import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import { Admin } from "../../../../models";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import { ROUTES } from "../../../../history";

import AppLink from "../../../../components/AppLink";
import { reduceString, titleCase } from "../../../../helpers";
import { blue } from "@mui/material/colors";
import useHover from "../../../../hooks/useHover";
import RelicAvatar from "../../../../components/RelicAvatar";

const AdminListWidget: React.FC<{
  admin: Admin;
  active?: boolean;
  avatarBgColor?: string;
  tableRow?: boolean;
  onClickCheck?: (p: Admin) => void;
}> = ({
  admin,
  active = false,
  tableRow = false,
  avatarBgColor = blue[500],
  onClickCheck,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hoverRef, isHovered] = useHover<any>();
  const name = titleCase(`${admin.Name}`);

  if (tableRow) {
    return (
      <TableRow>
        <TableCell component="th" scope="row">
          <Box display="flex" alignItems={"center"}>
            <Box
              display="inline-block"
              sx={{
                mr: 1,
              }}
            >
              <Checkbox
                checked={active}
                onChange={() => {
                  if (onClickCheck) {
                    onClickCheck(admin);
                  }
                }}
                sx={{
                  display: isHovered || active ? "inline-block" : "none",
                }}
              />

              <RelicAvatar
                size={40}
                display={!(isHovered || active)}
                user={
                  {
                    FirstName: admin.Name,
                    LastName: "",
                    CompletedRegistration: true,
                  } as any
                }
                avatarBgColor={avatarBgColor}
              />
            </Box>
            <AppLink
              doNotUseButton
              to={ROUTES.ADMIN_BASE + "/admin-orgs/admins/view/" + admin.id}
            >
              <Typography component="span" fontSize="14px" fontWeight={"bold"}>
                {reduceString(name || "Error", 25)}
              </Typography>
            </AppLink>
          </Box>
        </TableCell>
        <TableCell align="right">{admin.Email}</TableCell>
        <TableCell align="right">{admin.Role}</TableCell>
        <TableCell align="right">
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE +
              (!admin.organization
                ? "/admin-orgs/create-organization?admin="
                : `/admin-orgs/view/${admin.organization}?admin=`) +
              admin.id
            }
          >
            <Typography component="span" fontSize="14px" fontWeight={"bold"}>
              {(admin.organization ? "View" : "Add") + " organization"}
            </Typography>
          </AppLink>
        </TableCell>
      </TableRow>
    );
  }
  return (
    <Box
      padding="1.5em"
      borderRadius={"20px"}
      display={"flex"}
      sx={{
        mb: 2,
        backgroundColor: active ? "#4483FF" : "#F8F8FA",
        color: active ? "white" : "black",

        maxWidth: "400px",

        alignItems: "center",
      }}
    >
      <RelicAvatar
        size={40}
        display={!(isHovered || active)}
        user={
          {
            FirstName: admin.Name,
            LastName: "",
            CompletedRegistration: true,
          } as any
        }
        avatarBgColor={avatarBgColor}
      />
      <Box
        flexGrow={1}
        sx={{
          pl: 2,
        }}
      >
        <Typography fontWeight={"bold"} color="inherit">
          {reduceString(name || "Error", 25)}
        </Typography>
        <Typography color="inherit" fontSize={"12px"} fontWeight={300}>
          {admin.Email}
        </Typography>
      </Box>
      <AppLink
        doNotUseButton
        to={ROUTES.ADMIN_BASE + "/admins/view/" + admin.id}
      >
        <IconButton color="inherit">
          <ChevronRightIcon />
        </IconButton>
      </AppLink>
    </Box>
  );
};

export default AdminListWidget;
